import React from 'react';
import { Link } from 'react-router-dom';
import {ArrowLeft, Train, CreditCard, DollarSign} from 'lucide-react';

const transportGuides = [
  {
    destination: 'Japan',
    system: 'Japan Rail (JR) & Metro',
    card: 'Suica / Pasmo',
    cardCost: '¥500 deposit + ¥1,500 minimum',
    tips: [
      'JR Pass: ¥29,650 (7-day) - Worth it if traveling between cities',
      'Metro passes: ¥800/day for unlimited Tokyo Metro/Toei rides',
      'IC cards work on trains, buses, vending machines, and convenience stores',
      'Stand on left side of escalators (right in Osaka)',
      'Trains are punctual to the second'
    ]
  },
  {
    destination: 'Singapore',
    system: 'MRT (Mass Rapid Transit)',
    card: 'EZ-Link Card',
    cardCost: 'S$10 (S$5 stored value)',
    tips: [
      'Tourist Pass: S$20/day, S$26/2-day, S$30/3-day for unlimited travel',
      'Peak hours: 7-9 AM, 5-7 PM (avoid if possible)',
      'Eating and drinking prohibited on MRT (S$500 fine)',
      'Buses require exact fare or EZ-Link',
      'Airport to city: S$2.50 via MRT (~45 mins)'
    ]
  },
  {
    destination: 'Hong Kong',
    system: 'MTR (Mass Transit Railway)',
    card: 'Octopus Card',
    cardCost: 'HK$150 (HK$50 deposit)',
    tips: [
      'Airport Express: HK$115 one-way, HK$205 round-trip',
      'Octopus works on MTR, buses, ferries, trams, 7-Eleven',
      'Tourist Day Pass: HK$65 unlimited rides',
      'Peak hours: 7:30-9:30 AM, 5:30-7:30 PM',
      'Star Ferry is scenic and cheap (HK$3.70)'
    ]
  },
  {
    destination: 'USA (Orlando)',
    system: 'Lynx Bus & I-Ride Trolley',
    card: 'Rental Car (Recommended)',
    cardCost: '$30-60/day for car rental',
    tips: [
      'Public transport is limited - car highly recommended',
      'I-Ride Trolley: $2/ride, $5/day (International Drive only)',
      'Theme park shuttles often provided by hotels',
      'Uber/Lyft widely available',
      'Parking at Universal: $30/day, Disney: $25/day'
    ]
  }
];

export default function Transport() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#F7B32B] to-[#ffbe42] text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/guides" className="inline-flex items-center text-gray-100 hover:text-white mb-4 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Guides
          </Link>
          <h1 className="text-5xl font-bold mb-4">Transport Guides</h1>
          <p className="text-xl text-gray-100">Navigate public transport like a local</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid gap-8">
          {transportGuides.map((guide, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-8">
              <h2 className="text-3xl font-bold text-[#0A2540] mb-6">{guide.destination}</h2>
              
              <div className="grid md:grid-cols-3 gap-6 mb-6">
                <div className="bg-[#F5F5F5] rounded-lg p-6">
                  <div className="flex items-center mb-3">
                    <Train className="w-6 h-6 text-[#FF6B35] mr-2" />
                    <h3 className="font-semibold text-[#0A2540]">System</h3>
                  </div>
                  <p className="text-gray-700">{guide.system}</p>
                </div>

                <div className="bg-[#F5F5F5] rounded-lg p-6">
                  <div className="flex items-center mb-3">
                    <CreditCard className="w-6 h-6 text-[#4A90E2] mr-2" />
                    <h3 className="font-semibold text-[#0A2540]">Travel Card</h3>
                  </div>
                  <p className="text-gray-700">{guide.card}</p>
                </div>

                <div className="bg-[#F5F5F5] rounded-lg p-6">
                  <div className="flex items-center mb-3">
                    <DollarSign className="w-6 h-6 text-[#F7B32B] mr-2" />
                    <h3 className="font-semibold text-[#0A2540]">Cost</h3>
                  </div>
                  <p className="text-gray-700">{guide.cardCost}</p>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-[#FF6B35] mb-4">Essential Tips</h3>
                <ul className="space-y-3">
                  {guide.tips.map((tip, i) => (
                    <li key={i} className="flex items-start">
                      <div className="w-2 h-2 bg-[#4A90E2] rounded-full mt-2 mr-3 flex-shrink-0"></div>
                      <span className="text-gray-700">{tip}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}